import { createSelector } from 'reselect';

import { DEFAULT_VIEW_ID } from 'uf/views';

import { makeGetExploreByProjectState } from './explore';
import { makeGetProjectViewsForDisplay } from 'uf/views/selectors/views';
import { getUserActiveOrganizationFlags } from 'uf/user/selectors/flags';

/**
 * Get the active view id from project state
 * @deprecated use `selectActiveViewId` to grab value from app state
 * @returns a view id
 */
export function makeGetActiveViewId() {
  return createSelector(
    makeGetExploreByProjectState(),
    makeGetProjectViewsForDisplay(),
    getUserActiveOrganizationFlags,
    (state, views, flags) => {
      const hasSharedSavedViews = flags.includes('shared-saved-views');
      const defaultId = hasSharedSavedViews ? views?.[0]?.key : DEFAULT_VIEW_ID;
      return state?.activeViewId ?? defaultId;
    },
  );
}
